import { render, staticRenderFns } from "./ProjectComponent.vue?vue&type=template&id=1e4892bc&"
import script from "./ProjectComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectComponent.vue?vue&type=style&index=0&id=1e4892bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports